import { NativeError, RuntimeError } from '@belimo-retrofit-portal/logic';
import { SagaIterator } from 'redux-saga';
import { decodeOrGet } from 'src/io/utils/decodeOrGet';
import { PROJECT_LIST_COLUMN_LIST } from 'src/modules/project-list/codecs/ProjectListColumn';
import { PROJECT_LIST_COLUMNS_VERSION, PROJECT_LIST_DEFAULT_COLUMNS } from 'src/modules/project-list/constants/columns';
import { ProjectListColumn } from 'src/modules/project-list/types/ProjectListColumn';
import { storageGet } from 'src/sagas/utils/storage';
import { call } from 'typed-redux-saga';

export function* loadProjectListColumns(): SagaIterator<ReadonlyArray<ProjectListColumn>> {
  try {
    const raw = yield* call(storageGet, `project-list-columns-${PROJECT_LIST_COLUMNS_VERSION}`);
    return yield* call(decodeOrGet, PROJECT_LIST_COLUMN_LIST, raw, PROJECT_LIST_DEFAULT_COLUMNS);
  } catch (error) {
    throw new RuntimeError('Could not load project list columns', {}, NativeError.wrap(error));
  }
}
